import React from 'react';
import styled from '@emotion/styled';
import { useStoreState } from 'easy-peasy';

import { numberFormat } from '~/core/scripts/utils';

const LegendWrapper = styled.div`
  max-width: 400px;
  margin: 24px auto 12px;
  flex-wrap: wrap;
  flex-direction: column;
`;

const LegendTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.sans};
  color: ${({ theme }) => theme.colors.black};
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.1px;
  text-align: center;
  display: none; /* uncomment if needed but for now it's too much */
`;

const LegendBody = styled.div`
  display: flex;
  align-items: center;
`;

const LegendLabel = styled.div`
  padding: 0 5px;
`;

const LegendItemsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-basis: 100%;
`;

const LegendItem = styled.div`
  width: 100%;
  height: 9px;
  background: ${(p) => p.color};
`;

const Legend = () => {
  const colorScale = useStoreState((state) => state.app.colorScale);
  const selectedIndicator = useStoreState(
    (state) => state.app.selectedIndicator
  );
  const steps = colorScale.quantiles();
  const domain = colorScale.domain();
  const min = domain[0];
  const max = domain[domain.length - 1];

  return (
    <LegendWrapper>
      <LegendTitle>{selectedIndicator.label}</LegendTitle>
      <LegendBody>
        <LegendLabel>
          {numberFormat(min, selectedIndicator.decimals)}
        </LegendLabel>
        <LegendItemsWrapper>
          {steps.map((step, i) => (
            <LegendItem key={`legend-item-${i}`} color={colorScale(step)} />
          ))}
        </LegendItemsWrapper>
        <LegendLabel>
          {numberFormat(max, selectedIndicator.decimals)}
        </LegendLabel>
      </LegendBody>
    </LegendWrapper>
  );
};

export default Legend;
